import type { Action } from 'redux'
import type { StreamDefinition } from '../../../signalr/types'
import { defaultGetParams as getParams } from '../../../signalr/helpers'
import { getActivityTickerSuccess } from './actions'
import type { TickerInfo } from './types'

export const fetchActivityTickerDefinition: StreamDefinition<
  [],
  TickerInfo[],
  Action
> = {
  method: 'GetActivityTicker',
  strategy: 'switch',
  getParams,
  mapResponse: getActivityTickerSuccess,
  errorAction: 'activityticker.fetchFail',
  cancelOn: ['activityticker.fetchCancel']
}
